import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from './utilites';

export default class Tablesjs {
    constructor() {
        this.utilsjs = new Utilitiesjs
    }

    showMoreResults(tableId) {
        var rows = document.getElementById(tableId).rows;
        this.showMoreRows(rows, 10);
    }

    showMoreRows(rows, startRowNumber) {
        let that = this;
        if (startRowNumber <= rows.length) {
            if (rows[startRowNumber - 1].style.display === 'none') {
                that.showMoreRows(rows, startRowNumber + 10);
            } else {
                let maxCount = startRowNumber + 10 > rows.length ? rows.length : startRowNumber + 10;
                for (let rowNumber = startRowNumber; rowNumber < maxCount; rowNumber++) {

                    rows[rowNumber].style.display = 'table-row';
                    rows[rowNumber].removeAttribute("hidden");
                }
                let rowNumberHide = startRowNumber - 10 > 0 ? startRowNumber - 10 : 1;
                for (rowNumberHide; rowNumberHide < startRowNumber; rowNumberHide++) {
                    rows[rowNumberHide].style.display = 'none';
                }
            }
        }
    }

    showLessResults(tableId) {
        var rows = document.getElementById(tableId).rows;
        this.showLessRows(rows);
    }

    firstRowVisible(rows) {
        for (let rowNumer = 0; rowNumer < rows.length; rowNumer++) {
            if (rows[rowNumer].style.display === 'table-row') {
                return rowNumer;
            }
        }
    }

    showLessRows(rows) {
        var that = this;
        let startRowNumber = that.firstRowVisible(rows);
        if (startRowNumber - 10 >= 0) {
            startRowNumber = startRowNumber - 10 > 0 ? startRowNumber : startRowNumber + 1;
            for (let rowNumber = startRowNumber - 10; rowNumber < startRowNumber; rowNumber++) {
                rows[rowNumber].style.display = 'table-row';
                rows[rowNumber].removeAttribute('hidden');
            }

            let maxCount = startRowNumber + 10 > rows.length ? rows.length : startRowNumber + 10;
            for (let rowNumber = startRowNumber; rowNumber < maxCount; rowNumber++) {
                rows[rowNumber].style.display = 'none';
            }

        } else {

            let leftOver = rows.length % 10;
            if (leftOver > 0) {
                for (let rowNumber = 1; rowNumber <= 10; rowNumber++) {
                    rows[rowNumber].style.display = 'table-row';
                    rows[rowNumber].removeAttribute("hidden");
                }
                for (let rowNumber = 11; rowNumber < leftOver + 10; rowNumber++) {
                    rows[rowNumber].style.display = 'none';
                }
            }

        }

    }


    filterTableContent(inputId, tableId) {
        var input = document.getElementById(inputId);
        var filter = input.value.toUpperCase();
        var table = document.getElementById(tableId);
        var rows = table.getElementsByTagName("tr");

        for (var i = 0; i < rows.length; i++) {
            let cells = rows[i].getElementsByTagName("td")[0];
            if (cells) {
                let txtValue = cells.textContent || cells.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    rows[i].style.display = "";
                } else {
                    rows[i].style.display = "none";
                }
            }
        }
    }


    openUrl(action, controller, queryStringFullyFormed, paramEleIds = []) {
        let url = `${window.location.protocol}//${window.location.host}/${controller}/${action}${queryStringFullyFormed}`;
        if (paramEleIds && paramEleIds.length > 0) {
            let queryString = "";
            paramEleIds.forEach(eleId => {
                const paramEle = document.getElementById(eleId);
                queryString += `&${paramEle.name}=${paramEle.value}`;
            });

            if (!queryStringFullyFormed) {
                url += "?" + queryString.substring(1);
            }
            else {
                url += queryString;
            }
        }
        window.location.href = url;
    }

    openUrlNewTab(action, controller, queryStringFullyFormed, paramEleIds = []) {
        let url = `${window.location.protocol}//${window.location.host}/${controller}/${action}${queryStringFullyFormed}`;
        if (paramEleIds && paramEleIds.length > 0) {
            let queryString = "";
            paramEleIds.forEach(eleId => {
                const paramEle = document.getElementById(eleId);
                queryString += `&${paramEle.name}=${paramEle.value}`;
            });

            if (!queryStringFullyFormed) {
                url += "?" + queryString.substring(1);
            }
            else {
                url += queryString;
            }
        }
        window.open(url, '_blank');
    }

}


// WEBPACK FOOTER //
// ./Scripts/es6/tables.js